import type { FunctionComponent } from 'react';
import LoadingSection from '../../LoadingSection';
import {
  BestValueBadge,
  PerksListContainer,
  PRICE_ID_CONTAINER,
  type AnnualPlanCardProps,
} from '../shared';
import * as styles from '../shared/SharedPlanStyles.module.scss';
import * as annualStyles from './AnnualPlanCard.module.scss';

const AnnualPlanCard: FunctionComponent<AnnualPlanCardProps> = ({
  perksList,
  title,
  subtitle,
  price,
  isLoadingPrice,
  onSelectPlan,
  isSelected,
  annualPrice,
}) => {
  return (
    <div
      onClick={onSelectPlan}
      role="button"
      tabIndex={0}
      onKeyDown={onSelectPlan}
      id="annual-plan"
      className={`
        ${styles.planCardContainer}
        ${isSelected ? styles.plansOptionsSelected : ''}`}
      data-testid="annual-plan-select"
    >
      <div className={styles.planSelectedLabel}>Selected Plan</div>
      <div className={styles.plansContent}>
        <div className={styles.plansPriceContainer}>
          <div className={styles.plansTitle}>
            <h4>{title}</h4>
            <BestValueBadge />
          </div>
          <p className={annualStyles.planSubTitle}>{subtitle}</p>
          <p data-testid={PRICE_ID_CONTAINER} className={styles.plansContentPrice}>
            ${!isLoadingPrice ? price : <LoadingSection height={42} width={50} />}{' '}
            <span>USD Per Box</span>
          </p>
          <p className={annualStyles.planDisclaimer}>
            You will be billed $
            {!isLoadingPrice ? annualPrice : <LoadingSection height={12} width={50} />}
            &nbsp;annually.
          </p>
        </div>
        <hr className={styles.plansLineDivider} />
        <PerksListContainer perksList={perksList} />
      </div>
    </div>
  );
};

export default AnnualPlanCard;
